module.exports = __webpack_public_path__ + "img/MGH-Toyosu-12.1d086509.jpg";